import { type RadioGroupProps } from 'antd';
import { useField } from 'formik';
import { memo } from 'react';
import { useThemeComponents } from '../../themes';
import FormItem, { type FormItemProps } from './FormItem';

export interface RadioGroupFieldProps extends Omit<RadioGroupProps, 'onChange'> {
    name: string;
    label?: string;
    itemProps?: Omit<FormItemProps, 'label' | 'meta' | 'required' | 'children'>;
    required?: boolean;
}

const RadioField = ({ name, required, label, itemProps, ...props }: RadioGroupFieldProps) => {
    const [field, meta] = useField({ name });
    const { RadioGroup } = useThemeComponents();

    return (
        <FormItem {...itemProps} label={label} meta={meta} required={required}>
            <RadioGroup
                checked={field.value}
                // spread props
                {...props}
                // then spread the field properties itself
                {...field}
            />
        </FormItem>
    );
};

export default memo(RadioField);
